export default __webpack_public_path__ + "static/Baked2-84063e9a9212dc48fcc788734c6e8128.png";